<template>
  <section
    id="aos-section6"
    :class="[
      `relative flex flex-col items-center overflow-hidden p-5 lg:h-auto lg:p-[60px]`,
      locale === 'ko' ? 'h-[668px]' : 'h-[560px]'
    ]"
  >
    <div class="relative flex flex-1 flex-col items-center self-stretch rounded-3xl bg-blue-50 lg:rounded-[80px]">
      <div class="gn-container relative w-full flex-1 gap-7 px-4 py-10 lg:w-fit lg:gap-16 lg:py-[100px]">
        <i18n-t
          keypath="main.section6.title"
          tag="p"
          data-aos="fade-up"
          data-aos-anchor="#aos-section6"
          class="gn-text-3xl px-6 font-bold md:whitespace-pre-line"
        >
          <template #title-suffix>
            <span class="font-extrabold">{{ $t('main.section6.title-suffix') }}</span>
          </template>
        </i18n-t>

        <div
          data-aos="fade-up"
          data-aos-anchor="#aos-section6"
          class="flex w-full flex-col justify-center rounded-3xl bg-blue-500 px-7 py-5 lg:rounded-[80px] lg:px-[80px] lg:py-[70px]"
        >
          <i18n-t
            keypath="main.section6.subText"
            tag="p"
            class="gn-text-sm lg:gn-text-2xl text-start font-bold text-blue-100 text-white md:whitespace-pre-line lg:max-w-[75%]"
          >
            <template #subText-prefix>
              <span class="font-extrabold">
                {{ $t('main.section6.subText-prefix') }}
              </span>
            </template>
          </i18n-t>
        </div>

        <div
          v-if="locale === 'ko'"
          data-aos="fade-up"
          data-aos-anchor="#aos-section6"
          data-aos-delay="1000"
          class="w-full text-start lg:ps-[calc(100px)]"
        >
          <div class="flex flex-col gap-4 lg:w-[60%]">
            <p class="gn-text-xl font-extrabold">노규식 박사</p>
            <p class="gn-text-base font-normal">
              · 연세대학교 의과대학 졸업, 석박사 <br />· 연세 휴 클리닉, 노규식 공부 두뇌 연구원장 <br />· tvN
              '문제적남자', SBS '영재발굴단', '우리 아이가 달라졌어요 리턴즈' 출연 및 자문 <br />· 가디앤 연구 및 개발
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      data-aos="fade-up"
      data-aos-delay="1000"
      data-aos-anchor="#aos-section6"
      class="absolute bottom-0 overflow-hidden lg:right-10"
    >
      <OptimizedImage
        base-path="image/home/img_dr"
        :file-name="localImageFileName"
        :alt="localImageFileName"
        image-class="object-contain max-h-[245px] w-[40vw] min-w-52 max-w-[528px] lg:max-h-fit"
      />
    </div>
  </section>
</template>

<script setup>
import OptimizedImage from '~/components/common/OptimizedImage.vue'

const {locale} = useI18n()
const localImageFileName = computed(() => {
  return locale.value === 'ko' ? 'img_dr_roh' : 'img_dr_en'
})
</script>

<style lang="scss" scoped></style>
